

import type { D20Roll, D12PairRoll, DiceNotation, HitResult } from "./types";


export type Rng = () => number;

export const defaultRng: Rng = Math.random;


export function rollInt(min: number, max: number, rng: Rng = defaultRng): number {
  return Math.floor(rng() * (max - min + 1)) + min;
}

export function rollD20(modifier: number, rng: Rng = defaultRng): D20Roll {
  const raw = rollInt(1, 20, rng);
  return { raw, modifier, total: raw + modifier };
}

export function roll2d12(rng: Rng = defaultRng): D12PairRoll {
  return {
    hope: rollInt(1, 12, rng),
    fear: rollInt(1, 12, rng),
  };
}


export function resolveHit(
  hitMod: number,
  targetEvasion: number,
  rng: Rng = defaultRng,
  source: "hero" | "enemy" = "hero",
  critThreshold = 20,
  precomputedEnemyRolls?: { a: number; b: number },
): HitResult {
  if (source === "enemy") {
    const a = precomputedEnemyRolls ? precomputedEnemyRolls.a : rollInt(1, 12, rng);
    const b = precomputedEnemyRolls ? precomputedEnemyRolls.b : rollInt(1, 12, rng);
    const sum = a + b;
    const crit = a === b;
    const total = sum + hitMod;
    const roll: D20Roll = { raw: sum, modifier: hitMod, total };
    const hit = crit || total >= targetEvasion;
    return { source: "enemy", roll, targetEvasion, hit, crit, enemyRolls: { a, b } };
  }
  const raw = rollInt(1, 20, rng);
  const roll: D20Roll = { raw, modifier: hitMod, total: raw + hitMod };
  const crit = raw >= critThreshold;
  const hit = crit || roll.total >= targetEvasion;
  return { source: "hero", roll, targetEvasion, hit, crit };
}


export interface DiceRollResult {
  rolls: number[];
  sum: number;
}
export function rollDice(notation: DiceNotation, rng: Rng = defaultRng): DiceRollResult {
  const rolls: number[] = [];
  for (let i = 0; i < notation.count; i++) {
    rolls.push(rollInt(1, notation.sides, rng));
  }
  return { rolls, sum: rolls.reduce((a, b) => a + b, 0) };
}


export function generateDiceAnimation(finalValue: number, sides: number, frames: number): number[] {
  const result: number[] = [];
  for (let i = 0; i < frames - 1; i++) {
    result.push(rollInt(1, sides));
  }
  result.push(finalValue);
  return result;
}
